import { UpdateMainFiltersRoPayload } from '../../reducers/main-filter-retailer-overview/MainFiltersRoReducer';
import { MainFiltersRoActionType } from '../Type';
import { BaseTimePeriod } from '@services/FiltersTypes';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';
import { RelativePeriod } from '@components/comparison-period-selector/Types';
import { CustomMonthsPeriodState, CustomWeeksPeriodState } from '../../reducers/main-filter/MainFiltersReducer';

export const updateMainFiltersRO = (payload: UpdateMainFiltersRoPayload): MainFiltersRoAction => {
  return {
    type: MainFiltersRoActionType.UpdateMainFiltersRo,
    payload: payload,
  };
};

export const updateMainFiltersROPeriod = (payload: BaseTimePeriod): MainFiltersRoAction => {
  return {
    type: MainFiltersRoActionType.UpdateMFROPeriod,
    payload: payload,
  };
};

export const updateMainFiltersROPeriodicity = (payload: Periodicity): MainFiltersRoAction => {
  return {
    type: MainFiltersRoActionType.UpdateMFROPeriodicity,
    payload: payload,
  };
};

export const updateMainFiltersROComparisonPeriod = (payload: RelativePeriod | BaseTimePeriod): MainFiltersRoAction => {
  return {
    type: MainFiltersRoActionType.UpdateMFROComparisonPeriod,
    payload: payload,
  };
};

export const updateMainFiltersROCustomMonthsPeriodState = (payload: CustomMonthsPeriodState): MainFiltersRoAction => {
  return {
    type: MainFiltersRoActionType.UpdateMFROCustomMonthsPeriodState,
    payload: payload,
  };
};

export const updateMainFiltersROCustomWeeksPeriodState = (payload: CustomWeeksPeriodState): MainFiltersRoAction => {
  return {
    type: MainFiltersRoActionType.UpdateMFROCustomWeeksPeriodState,
    payload: payload,
  };
};

export type MainFiltersRoAction =
  | UpdateMainFiltersRoAction
  | UpdateMFROPeriodAction
  | UpdateMFROPeriodicityAction
  | UpdateMFROComparisonPeriodAction
  | UpdateMFROCustomMonthsPeriodStateAction
  | UpdateMFROCustomWeeksPeriodStateAction;

type UpdateMainFiltersRoAction = ActionType<MainFiltersRoActionType.UpdateMainFiltersRo> & {
  payload: UpdateMainFiltersRoPayload;
};

type UpdateMFROPeriodAction = ActionType<MainFiltersRoActionType.UpdateMFROPeriod> & {
  payload: BaseTimePeriod;
};

type UpdateMFROPeriodicityAction = ActionType<MainFiltersRoActionType.UpdateMFROPeriodicity> & {
  payload: Periodicity;
};

type UpdateMFROComparisonPeriodAction = ActionType<MainFiltersRoActionType.UpdateMFROComparisonPeriod> & {
  payload: RelativePeriod | BaseTimePeriod;
};

type UpdateMFROCustomMonthsPeriodStateAction = ActionType<MainFiltersRoActionType.UpdateMFROCustomMonthsPeriodState> & {
  payload: CustomMonthsPeriodState;
};

type UpdateMFROCustomWeeksPeriodStateAction = ActionType<MainFiltersRoActionType.UpdateMFROCustomWeeksPeriodState> & {
  payload: CustomWeeksPeriodState;
};

type ActionType<MainFiltersRoActionType> = {
  type: MainFiltersRoActionType;
};
